import { render, staticRenderFns } from "./ShingalOffice.vue?vue&type=template&id=747de7f5&scoped=true&"
import script from "./ShingalOffice.vue?vue&type=script&lang=js&"
export * from "./ShingalOffice.vue?vue&type=script&lang=js&"
import style0 from "./ShingalOffice.vue?vue&type=style&index=0&id=747de7f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747de7f5",
  null
  
)

export default component.exports